export const EXPAND = 'HEADER_EXPAND';
export const COLLAPSE = 'HEADER_COLLAPSE';
